module.exports = __webpack_public_path__ + "media/application/images/2018/2018-member-lock-64cec8817e96f09c56c6be3f5dbbc9fb.svg";